(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const STORAGE_KEY_PREFIX = 'ab_dismissed_';

  class AnnouncementBar {
    constructor(el) {
      this.el        = el;
      this.id        = el.dataset.announcementBar ? el.dataset.announcementBar : el.id.replace('announcement-bar-', '');
      this.slider    = el.querySelector('[data-announcement-slider]');
      this.slides    = Array.from(el.querySelectorAll('.announcement-bar__slide'));
      this.dots      = Array.from(el.querySelectorAll('.announcement-bar__dot'));
      this.prevBtn   = el.querySelector('[data-announcement-prev]');
      this.nextBtn   = el.querySelector('[data-announcement-next]');
      this.closeBtn  = el.querySelector('[data-announcement-close]');
      this.current   = 0;
      this.total     = this.slides.length;
      this.interval  = null;

      // Read auto-rotate delay from CSS variable (set via section settings)
      const style    = getComputedStyle(el);
      const speed    = parseInt(style.getPropertyValue('--ab-transition') || '400', 10);
      this.delay     = parseInt(el.dataset.rotateDelay || '4000', 10);

      this.init();
    }

    init() {
      // Check if previously dismissed
      if (sessionStorage.getItem(STORAGE_KEY_PREFIX + this.id)) {
        this.el.style.display = 'none';
        return;
      }

      this.goTo(0);
      this.startAuto();
      this.bindEvents();
      this.initCountdowns();
    }

    goTo(index) {
      this.slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === index);
      });
      this.dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === index);
      });
      this.current = index;
    }

    next() {
      this.goTo((this.current + 1) % this.total);
    }

    prev() {
      this.goTo((this.current - 1 + this.total) % this.total);
    }

    startAuto() {
      if (this.total <= 1) return;
      this.interval = setInterval(() => this.next(), this.delay);
    }

    stopAuto() {
      clearInterval(this.interval);
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.stopAuto(); this.prev(); this.startAuto(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.stopAuto(); this.next(); this.startAuto(); });

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => { this.stopAuto(); this.goTo(i); this.startAuto(); });
      });

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => {
          this.stopAuto();
          this.el.style.display = 'none';
          try { sessionStorage.setItem(STORAGE_KEY_PREFIX + this.id, '1'); } catch(e) {}
        });
      }

      // Pause on hover
      this.el.addEventListener('mouseenter', () => this.stopAuto());
      this.el.addEventListener('mouseleave', () => this.startAuto());

      // Touch / swipe support
      let startX = null;
      this.el.addEventListener('touchstart', (e) => { startX = e.changedTouches[0].clientX; }, { passive: true });
      this.el.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          this.stopAuto();
          diff > 0 ? this.next() : this.prev();
          this.startAuto();
        }
        startX = null;
      }, { passive: true });
    }

    initCountdowns() {
      const countdownEls = this.el.querySelectorAll('[data-countdown]');
      if (!countdownEls.length) return;

      const pad = (n) => String(n).padStart(2, '0');

      const tick = () => {
        countdownEls.forEach((el) => {
          const end  = parseInt(el.dataset.countdown, 10);
          const now  = Date.now();
          const diff = end - now;

          if (diff <= 0) {
            el.textContent = '00:00:00:00';
            return;
          }

          const d  = Math.floor(diff / 86400000);
          const h  = Math.floor((diff % 86400000) / 3600000);
          const m  = Math.floor((diff % 3600000) / 60000);
          const s  = Math.floor((diff % 60000) / 1000);

          el.textContent = d > 0
            ? `${pad(d)}d ${pad(h)}h ${pad(m)}m ${pad(s)}s`
            : `${pad(h)}:${pad(m)}:${pad(s)}`;
        });
      };

      tick();
      setInterval(tick, 1000);
    }
  }

  // Boot all bars on the page
  function init() {
    document.querySelectorAll('[id^="announcement-bar-"]').forEach((el) => {
      if (!el.dataset.abInit) {
        el.dataset.abInit = '1';
        // Expose rotate delay from section setting via data attr if needed
        // (set in schema default, overridden in HTML via Liquid)
        new AnnouncementBar(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer-hulkapps-backup"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
